<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="comofunciona">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm11 elevation-6>
                
                            
                <guia-interpretacion></guia-interpretacion>
                           
                        
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>

import GuiaInterpretacion from '@/components/GuiaInterpretacion';

export default {
    name: 'comofunciona',
    data()
    {
        return {
            
        };
    },

    methods:
    {
    },

    components:
    {
        GuiaInterpretacion,
    }
};
</script>

<style scoped>
.comofunciona {
    background: url('../assets/alex-kotliarskyi-QBpZGqEMsKg-unsplash.jpg');
    background-size: cover;
    width: 100%;
    height: 100%;
}



/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>